import React, { useState, useEffect } from "react";
// import Ellipse from "../assets/img/Ellipse 1.png";
import Layout from "../layout/Layout";
import ReactTooltip from "react-tooltip";
import { Tooltip, Button } from "@material-tailwind/react";
import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";
import Line from "../assets/img/Line.png";
import Isocompliance from "../assets/svg/Iso_logo.svg";
import File from "../assets/img/fileplace.png";

import axiosInstanceAuth from "../../apiInstances/axiosInstanceAuth";
import useEncryption from "../useEncryption/useEncryption";
import { BACKEND_BASE_URL } from "../../apiInstances/baseurl";

const Profile = ({ value }) => {
  const { decryptData } = useEncryption();

  // const [profileData, setProfileData] = useState([]); // use User Table time this state
  const [userProfile, setUserProfile] = useState({});
  const [adminProfile, setAdminProfile] = useState({});

  const userRole = localStorage.getItem("Role");

  const getAdminProfile = async () => {
    await axiosInstanceAuth
      .get("/admin_profile")
      .then((res) => {
        const myData = decryptData(res?.data?.data);
        setAdminProfile(myData?.data || []);
        console.log("Admin ProfileData---->", myData?.data);
      })
      .catch((err) => {
        console.log("err --->", err);
      });
  };
  const getUserProfile = async () => {
    await axiosInstanceAuth
      .get("/user_profile")

      .then((res) => {
        const myData = decryptData(res?.data?.data);
        setUserProfile(myData?.data || []);
        console.log("User ProfileData---->", myData?.data);
      })
      .catch((err) => {
        console.log("err --->", err);
      });
  };

  // useEffect(() => {
  //   getAdminProfile();
  //   getUserProfile();
  // }, []);
  useEffect(() => {
    if (userRole === "admin") {
      getAdminProfile();
    } else {
      getUserProfile();
    }
  }, []);
  return (
    <Layout>
      <div className="flex mt-5 md:ml-12 ml-4">
        <img src={Line} alt="" className="" />
        <p className="ml-2 text-[#22345C] md:text-3xl text-2xl font-semibold">
          Profile
        </p>
      </div>
      <div className="border-[1.5px] bg-[#FFFFFF] md:m-10 m-2  rounded-3xl shadow-xl">
        {/* <div className="flex justify-end mr-5 mt-5 cursor-pointer">
          <PiDotsThreeOutlineVerticalFill size={25} />
        </div> */}
        <div class="grid lg:grid-cols-12 grid-cols-3 gap-4 p-5">
          <div class="grid col-span-2 mx:p-10 md:mt-5 ml-5 p-2 mx:mr-10 ">
            <img
              class=" lg:w-[186px] lg:h-[186px] rounded-lg"
              // src={File}
              src={`${BACKEND_BASE_URL}${
                userRole === "admin" ? adminProfile.logo : userProfile.logo
              }`}
              alt=""
            />
          </div>

          <div class=" grid lg:col-span-5  col-span-5  lg:p-10 md:ml-10 lg:ml-1">
            <div className="mt-">
              <p className="font-semibold text-2xl text-[#22345C]">
                {userRole === "admin" ? adminProfile.name : userProfile.name}
              </p>
              <p className="font-normal text-base text-[#828282]">
                {userRole === "admin" ? adminProfile.role : userProfile.role}
              </p>
            </div>

            <div className="space-y-2 md:mt-5 mt-7">
              <p className="font-normal text-base text-[#828282]">
                <span className="font-bold">Email : </span>
                {userRole === "admin" ? adminProfile.email : userProfile.email}
              </p>
              {/* <p className="font-normal text-sm text-[#131313]">
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s,
              </p> */}
            </div>

            <div className="space-y-2 md:mt-5 mt-7">
              {userRole !== "admin" && (
                <p className="font-normal text-base text-[#828282]">
                  <span className="font-bold">Phone No: </span>
                  {userRole === "admin"
                    ? adminProfile.phone
                    : userProfile.phone}
                </p>
              )}
            </div>

            {/* <div className="space-y-2 mt-5">
              <p className="font-normal text-sm text-[#828282]">
                Candidate Shortlisted rate among all Applicants
              </p>
            </div> */}

            {/* <div className="relative pt-1 md:mt-5 mt-7">
              <Tooltip
                placement="top-end"
                effect="solid"
                content={`${20}%`}
                className="bg-[#AAF4CF] text-[#000000] font-semibold"
              >
                <div className="overflow-hidden h-2 mb-4 text-xs flex rounded bg-[#D9D9D9]">
                  <div
                    style={{ width: `${20}%` }}
                    className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-[#22345C]"
                  ></div>
                </div>
              </Tooltip>
            </div> */}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Profile;

// Hari corporation construction realated
